export const SparkAuctionEvent = {
  SparksAuctionPageView: 'sparks_auction_page_view',
  PlaceBidClick: 'place_bid_click',
  IncreaseBidClick: 'increase_bid_click',
  AuctionResultsClick: 'auction_results_click',
  OrderFormPlaceBidClick: 'order_form_place_bid_click',
  OrderFormAddBidClick: 'order_form_add_bid_click',
  AvailableSparksClick: 'available_sparks_click',
} as const;

export interface SparkAuctionEventDataType {
  [SparkAuctionEvent.SparksAuctionPageView]: {};
  [SparkAuctionEvent.PlaceBidClick]: {
    highest_bid: number | null; // Null if there’s no bidders yet
    available_sparks: number; // The number of sparks users currently have
    element_type: 'textlink' | 'button'; // which element type a user clicked
  };
  [SparkAuctionEvent.IncreaseBidClick]: {
    highest_bid: number | null;
    available_sparks: number;
    current_bid: number; // A user’s current bid
    days_remaining: number; // days remaining until the auction ends
  };
  [SparkAuctionEvent.AuctionResultsClick]: {
    username: string | null; // The winner of past auction
    num_sparks_bid: number | null; // The number of sparks a winner bid
    current_bid: number;
    highest_bid: number | null;
  };
  [SparkAuctionEvent.OrderFormPlaceBidClick]: {
    available_sparks: number;
    num_sparks: number; // The number of Sparks user received or spend
  };
  [SparkAuctionEvent.OrderFormAddBidClick]: {
    available_sparks: number;
    num_sparks: number;
    current_bid: number;
  };
  [SparkAuctionEvent.AvailableSparksClick]: {
    num_sparks: number;
  };
}
